export default __webpack_public_path__ + "static/media/vox-img-legacy-017.a92ac18e.jpg";